import type { FC } from "react";
import styled from "styled-components";

import aeviLogoShort from "./source/Aevi_Icon_lightgreen.png";
import aeviLogo from "./source/logo-aevi.png";
import aeviLogoBrand from "./source/logo-aevi-brand.svg";
import aeviLogoInverse from "./source/logo-aevi-inverse.png";
import aeviLogoRebrand from "./source/logo-aevi-rebrand.png";

export enum LogoSize {
    SMALL = "small",
    REGULAR = "regular",
    BIG = "big",
}

export enum Logos {
    AeviLogoInverse = "AeviLogoInverse",
    AeviLogo = "AeviLogo",
    AeviLogoBrand = "AeviLogoBrand",
    AeviLogoRebrand = "AeviLogoRebrand",
    AeviLogoShort = "AeviLogoShort",
}

const logosMap = new Map<Logos, string | unknown>([
    [Logos.AeviLogoInverse, aeviLogoInverse],
    [Logos.AeviLogo, aeviLogo],
    [Logos.AeviLogoBrand, aeviLogoBrand],
    [Logos.AeviLogoRebrand, aeviLogoRebrand],
    [Logos.AeviLogoShort, aeviLogoShort],
]);

type LogoProps = Readonly<{
    src: Logos;
    size?: LogoSize;
    className?: string;
}>;

export const Logo: FC<LogoProps> = ({ src, size, className }) => {
    const logo = logosMap.get(src);
    if (typeof logo === "string") {
        return <FlexLogo alt="Logo" src={logo} $size={size} className={className} />;
    }
    throw new Error("Could not set up png logo.");
};

const FlexLogo = styled.img<{ $size?: LogoSize }>`
    display: block;
    margin: 0 auto;

    padding: ${(props) => (props.$size === LogoSize.SMALL ? "10px 0" : "20px")};
    width: ${(props) => (props.$size === LogoSize.SMALL ? "40px" : "140px")};
`;
